import PouchLoadService from "external-services/pouch-load-service/index";

const NS = 'PlanFrameService';

export default function PlanFrameService(SnapConst, SnapService, PlanConst, Group, Structure) {
  "ngInject";

  function Frame(s, mode, model) {

    var defaults = {
      _id: PouchLoadService.getNewId(['structure']),
      type: Structure.Type,
      subType: Structure.SubTypes.FrameRect,
      width: 80,
      height: 40,
      rotation: 0,
      position: {
        x: 0,
        y: 0
      },
      fill: false
    };

    if (model.subType === Structure.SubTypes.FrameCircle) {
      defaults.height = 80;
    }

    this.s = s;
    this.mode = mode;
    this.model = _.extend({}, defaults, model);
    this.resizable = this.model.subType === Structure.SubTypes.FrameCircle ? _.clone(Frame.Resizable.Circle) : _.clone(Frame.Resizable.Rect);
    this.actions = this.model.subType === Structure.SubTypes.FrameCircle ? _.clone(Frame.Actions.Circle) : _.clone(Frame.Actions.Rect);
    this.render();
    this.refresh();
    this.place(this.model.position);
    this.rotate(this.model.rotation);
  }

  Frame.prototype = _.extend({}, new Structure(), {
    render: function () {
      this.element = new Group(this.s, 'Frame', {
        type: SnapConst.Shapes.Rect,
        w: this.model.width,
        h: this.model.height
      });
      SnapService.getElement(this.element).addClass('structure frame ' + this.model.subType).data()._id = this.model._id;
      //Body
      this.body = this.model.subType === Structure.SubTypes.FrameCircle ?
        this.s.rect(0, 0, this.model.width, this.model.height, this.model.width, this.model.height).addClass('body') :
        this.s.rect(0, 0, this.model.width, this.model.height).addClass('body');
      this.element.addElement(this.body, 'body');
      //Core
      this.core = this.model.subType === Structure.SubTypes.FrameCircle ?
        this.s.rect(1, 1, this.model.width - 2, this.model.height - 2, this.model.width - 2, this.model.height - 2).addClass('core') :
        this.s.rect(1, 1, this.model.width - 2, this.model.height - 2).addClass('core');
      this.element.addElement(this.core, 'core');
      //Label
      this.label = this.s.text(0, 0, this.model.label || "").addClass('label');
      this.element.addElement(this.label, 'label');
    },

    refresh: function (anchor) {

      var info = this.beforeResize(anchor);

      this.element.shape.w = this.model.width;
      this.element.shape.h = this.model.height;
      this.shape = this.element.shape;
      this.element.getSGroup().attr({
        width: this.model.width,
        height: this.model.height
      });
      this.body.attr({
        width: this.model.width,
        height: this.model.height
      });
      this.core.attr({
        width: this.model.width - 2,
        height: this.model.height - 2
      });
      if (this.model.subType === Structure.SubTypes.FrameCircle) {
        this.body.attr({
          rx: this.model.width,
          ry: this.model.height
        });
        this.core.attr({
          rx: this.model.width - 2,
          ry: this.model.height - 2
        });
      }

      this.element.getSGroup().toggleClass('fill', this.model.fill);

      //Label
      this.label.node.innerHTML = this.model.label || "";
      SnapService.place(this.label, (this.model.width) / 2, (this.model.height) / 2);

      this.afterResize(info);
    },

  });

  /************************************************************************************************************************
   *************************************************************************************************************************
   STATIC ATTRIBUTES AND FUNCTIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/

  Frame.Resizable = {
    Rect: {
      hStep: 20,
      hMin: 20,
      hMax: -1,
      wStep: 20,
      wMin: 20,
      wMax: -1
    },
    Circle: {
      hStep: 20,
      hMin: 20,
      hMax: -1,
      wStep: 20,
      wMin: 20,
      wMax: -1,
      keepRatio: false
    },
  };

  Frame.Actions = {
    Rect: {
      spread: true,
      rotate: true,
      edit: true
    },
    Circle: {
      spread: true,
      rotate: false,
      edit: true
    }
  };

  Frame.buildToolbarElement = function (s, type) {
    var g = new Group(s, 'Frame', {
      type: SnapConst.Shapes.Rect,
      w: 80,
      h: type === Structure.SubTypes.FrameCircle ? 80 : 40
    });
    g.getSGroup().addClass('structure frame ' + type);
    g.getSGroup().data('type', type);
    var body = type === Structure.SubTypes.FrameCircle ? s.rect(0, 0, 80, 80, 100, 100).addClass('body') : s.rect(0, 0, 80, 40).addClass('body');
    g.addElement(body, 'body');
    SnapService.place(body, 0, 0);
    var core = type === Structure.SubTypes.FrameCircle ? s.rect(0, 0, 78, 78, 100, 100).addClass('core') : s.rect(0, 0, 78, 38).addClass('core');
    g.addElement(core, 'core');
    SnapService.place(core, 1, 1);
    var label = s.text(0, 0, 'Text').addClass('label');
    g.addElement(label, 'label');
    SnapService.place(label, 80 / 2, type === Structure.SubTypes.FrameCircle ? 40 : 20);
    return g;
  };

  return Frame;
}
